import { parseDateString } from '../../../../utilities/parse-date-string.js'
import { parseNumber } from '../../../utilities/parse-number.js'

/**
 * Basics: Which property to map the fields from source data to parsed object
 * inputName
 * outputName
 *
 * Value to consider:
 * parseFunction(): function to execute
 * If no function: the value of the inputName property is used
 *
 * How to combine the orders lines
 * lineCombinationId: the field to use as aggregation Key
 *
 * lineCombination:
 * - 'first': record the first value (TODO: detection of mismatch?)
 * - 'sum': number
 * - 'records': array of values
 * - don't combine
 *
 * TODO:
 * quantity?
 * price to consider?
 *
 */

export const shopeeOrdersFieldsMapping = [
  {
    inputName: '??',
    outputName: 'orderId',
    lineCombination: 'first',
    lineCombinationId: true
  },
  {
    outputName: 'recordType',
    parseFunction: function () {
      return 'orderLine'
    }
  },
  {
    outputName: 'orderPlatform',
    parseFunction: function (record, context) {
      return context?.platform || undefined
    }
  },
  {
    outputName: 'orderCountry',
    parseFunction: function (record, context) {
      return context?.country || undefined
    }
  },
  {
    outputName: 'orderLines',
    lineCombination: 'records'
  },
  {
    inputName: '??? SKU (SKU Reference No.)',
    outputName: 'SKU_id'
  },
  {
    inputName: '??',
    outputName: 'buyerUsername',
    lineCombination: 'first'
  },
  {
    inputName: '??',
    outputName: 'orderStatus'
  },
  {
    inputName: '??',
    outputName: 'createdAt',
    parseFunction: function (value) {
      return parseDateString(value, { inputFormat: 'YYYY-MM-DD HH:mm' })
    },
    lineCombination: 'first'
  },
  {
    inputName: '??',
    outputName: 'completedAt',
    parseFunction: function (value) {
      return parseDateString(value, { inputFormat: 'YYYY-MM-DD HH:mm' })
    },
    lineCombination: 'first'
  },
  {
    inputName: '??',
    outputName: 'quantity',
    parseFunction: parseNumber,
    lineCombination: 'sum'
  },
  {
    inputName: '??',
    outputName: 'priceOriginal',
    parseFunction: parseNumber,
    lineCombination: 'sum'
  },
  {
    inputName: '??',
    outputName: 'priceProduct',
    parseFunction: parseNumber,
    lineCombination: 'sum'
  },
  {
    inputName: '??',
    outputName: 'revenueGross',
    parseFunction: parseNumber,
    lineCombination: 'sum'
  },
  {
    inputName: '?? (%)',
    outputName: 'transactionFee',
    parseFunction: function (value) {
      const parsedNumber = parseNumber(value)
      if (Number.isFinite(parsedNumber)) {
        return parsedNumber / 100
      }
      return parsedNumber
    }
  },
  {
    inputName: 'Country',
    outputName: 'shipCountry'
  }
]
